import { useState } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';

import Spinner from 'components/Spinner/Spinner';
import { useAppSelector } from 'app/hooks';
import { ResetPassword } from './ResetPassword';
import { NewPassword } from './NewPasswors';

export const Password = () => {
  const [searchParams] = useSearchParams();
  const code = searchParams.get('code');

  return <>{!code ? <ResetPassword /> : <NewPassword />}</>;
};
